// extracted by mini-css-extract-plugin
export default {"emptyState":"PopupContent_emptyState__8quDF","emptyIcon":"PopupContent_emptyIcon__d1uo1","loadingState":"PopupContent_loadingState__TSXMD","option":"PopupContent_option__82pRB"};